import { apiUrl } from "../config/apiUrls";
import { BASE_URL } from "../config/create-header";

// export const fetchUserCredits = async (userId) => {
//   const res = await fetch(`${BASE_URL}${apiUrl.subscriptionGetCredit}`, {
//     method: "POST",
//     body:JSON.stringify({userId})
//   });

//   if (!res.ok) throw new Error("Failed to fetch credits");

//   return res.json();
// };


export const fetchUserCredits = async ({
  userId,
  name,
  email,
}) => {
  // 1️⃣ check credits
  const creditRes = await fetch(
    `${BASE_URL}${apiUrl.subscriptionGetCredit}`,
    {
      method: "POST",
      body: JSON.stringify({ userId }),
    }
  );

  // 2️⃣ user not found → create user
  if (creditRes.status === 404) {
    const createRes = await fetch(
      `${BASE_URL}/api/users/one`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-signature": process.env.REACT_APP_API_SHARED_SECRET,
        },
        body: JSON.stringify({
          userId,
          name,
          email,
        }),
      }
    );

    if (!createRes.ok) {
      throw new Error("User creation failed");
    }

    // 3️⃣ retry credit fetch
    const retryRes = await fetch(
      `${BASE_URL}${apiUrl.subscriptionGetCredit}`,
      {
        method: "POST",
        body: JSON.stringify({ userId }),
      }
    );

    if (!retryRes.ok) {
      throw new Error("Failed to fetch credits after user creation");
    }

    return retryRes.json();
  }

  // 4️⃣ normal flow
  if (!creditRes.ok) {
    throw new Error("Failed to fetch credits");
  }

  return creditRes.json();
};
